import { auth } from "../Constant/Constant"

// ========================================
// USER MANAGEMENT
// ========================================

export const register = auth + 'register'
export const updateUser = auth + 'updateUser'
export const searchUser = auth + 'searchUser'
export const deleteUser = auth + 'deleteUser'


// ========================================
// ROLES AND PERMISSIONS
// ========================================
export const addRole = 'addRole'
export const updateRole = 'updateRole'
export const searchRole = 'searchRole'
export const deleteRole = 'deleteRole'


// ========================================
// Expense Management
// ========================================
export const addExpense = 'addExpense'
export const updateExpense = 'updateExpense'
export const searchExpense = 'searchExpense'
export const deleteExpense = 'deleteExpense'


// ========================================
// Cashbook Management
// ========================================

export const addCashRecord = "addCashRecord"
export const searchCashRecord = "searchCashRecords"
export const deleteCashRecord = 'deleteCashRecord'
export const updateCashrecord = 'updateCashrecord'
export const getCashRecordStats = 'statsCashRecord'



// ========================================
// Book Management
// ========================================

export const addBook = "addBook"
export const searchBook = "searchBook"
export const updateBook = "updateBook"
export const deleteBook = "deleteBook"





// ========================================
// Account Management
// ========================================

export const addAccount = 'addAccount'
export const updateAccount = 'updateAccount'
export const searchAccount = "searchAccount"
export const deleteAccount = "deleteAccount"






export const upload = 'upload'

